import { GET_MILEAGE_BEGIN, GET_MILEAGE_SUCCESS } from "./type";

const initialState = {
    items: [],
    loading: false
}
export const MileageReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MILEAGE_BEGIN:
            return {
                ...state,
                loading: true
            }
        case GET_MILEAGE_SUCCESS:
            return action.payload
        default:
            return state
    }
};
